import * as React from 'react';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import classNames from 'classnames';
import './language-switcher.scss';

export const LanguageSwitcher: React.FC = () => {
  const {
    t, language, languages, originalPath,
  } = useI18next();
  const [open, setOpen] = React.useState(false);

  const translationsLanguages = t('languages', {
    returnObjects: true,
  });

  const toggleMenuHandler = React.useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <div className="languages">
      <button className="languages__trigger" onClick={toggleMenuHandler}>
        {language}
      </button>
      <div className={classNames('languages__menu', { opened: open })}>
        <button className="languages__close-btn" onClick={toggleMenuHandler}>
          Close Icon
        </button>
        <ul className="languages__list">
          {languages.map((lng) => (
            <li
              key={lng}
              className={classNames('languages__item', { selected: lng === language })}
            >
              <Link
                to={originalPath}
                language={lng}
                className="languages__link"
              >
                {translationsLanguages[lng]}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
